import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react'
import { FiRefreshCw } from 'react-icons/fi'
import { PROTECTED_ROUTES } from '@/shared/config/routes'
import { ProtectedPage } from '@/shared/components/ProtectedPage'
import DuplicateRegistryView from './components/DuplicateRegistryView'
import { useDuplicateActions } from './hooks/useDuplicateActions'

/**
 * Duplicate Registration — the admin side of duplicate parent handling.
 *
 * One page, two grids: the list of suspected pairs, and the side-by-side
 * comparison of whichever pair is selected.
 */
const DuplicateRegistration = () => {
    const { rerunDetection, refreshing } = useDuplicateActions()

    return (
        <ProtectedPage
            routeConfig={PROTECTED_ROUTES['/user/teacher/duplicate-registration']}
        >
            <Box
                h={{ base: 'auto', md: 'calc(100vh - 96px)' }}
                minH={{ base: 'container.sm', md: '520px' }}
                borderRadius={4}
                bg={'white'}
                mx={'auto'}
                py={5}
                px={{ base: 2, md: 17 }}
                display="flex"
                flexDirection="column"
            >
                <Flex my={2} alignItems="center" gap="2" flexWrap="wrap">
                    <Box p="2">
                        <Heading size="md" my={2}>
                            Duplicate Registration
                        </Heading>
                        <Text color={'gray.600'}>
                            Parents who appear to have registered twice. Keep the correct
                            record and the other is merged into it.
                        </Text>
                    </Box>
                    <Box flex="1" />
                    {/* Detection runs nightly at 03:00 Africa/Lagos; this is for
                        when someone needs an answer before then. */}
                    <Button
                        size="sm"
                        variant="outline"
                        leftIcon={<FiRefreshCw />}
                        isLoading={refreshing}
                        onClick={() => rerunDetection().catch(() => {})}
                    >
                        Re-run detection
                    </Button>
                </Flex>

                <DuplicateRegistryView />
            </Box>
        </ProtectedPage>
    )
}

export default DuplicateRegistration
